import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  Divider,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import SuiBox from "components/SuiBox";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
function CardAdicionales({ proceso, adicionales }) {
  console.log(proceso.id);
  return (
    <Card
      sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", padding: 2 }}
    >
      <SuiBox p={1.5} display="flex" flexDirection="column" height="100%">
        {/* Personas a Cargo */}
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid size={12}>
            <Typography variant="h5">
              <FolderSharedIcon /> Personas a Cargo
            </Typography>
          </Grid>
        </Grid>
        {adicionales.personasCargo.length > 0 ? (
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}>
                    Identificación
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}>
                    Nombre Completo
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}>
                    Parentesco
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}>
                    Edad
                  </TableCell>
                </TableRow>
                <TableBody>
                  {adicionales.personasCargo.map((persona) => (
                    <TableRow key={persona.id}>
                      <TableCell sx={{ padding: "4px 8px" }}>
                        {persona.tipo_documento} - {persona.numero_documento}
                      </TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>{persona.nombre_completo}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>{persona.parentesco}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>{persona.edad}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        ) : (
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              <Typography>No hay Personas a Cargo.</Typography>
            </Grid>
          </Grid>
        )}
        <Divider sx={{ my: 1.25 }} />

        {/* Procesos Judiciales */}
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid size={12}>
            <Typography variant="h5">
              <AssuredWorkloadIcon /> Procesos Judiciales
            </Typography>
          </Grid>
        </Grid>
        {adicionales.procesosJudiciales.length > 0 ? (
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}>
                    Juzgado
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}>
                    No. Radicación
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}>
                    Demandado
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}>
                    Demandante
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}>
                    Email
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}>
                    Estado
                  </TableCell>
                </TableRow>
                <TableBody>
                  {adicionales.procesosJudiciales.map((proceso) => (
                    <TableRow key={proceso.id}>
                      <TableCell sx={{ padding: "4px 8px" }}>{proceso.juzgado}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>{proceso.radicado}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>{proceso.demandado}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>{proceso.demandante}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>{proceso.email}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>{proceso.estado_actual}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        ) : (
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              <Typography>No hay Procesos Judiciales registrados.</Typography>
            </Grid>
          </Grid>
        )}
        <Divider sx={{ my: 1.25 }} />

        {/* Sociedades */}
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid size={12}>
            <Typography variant="h5">
              <CorporateFareIcon /> Sociedades
            </Typography>
          </Grid>
        </Grid>
        {adicionales.sociedades.length > 0 ? (
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}>
                    Identificación
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}>
                    Nombre Completo
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}>
                    Tipo Sociedad
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}>
                    Dirección
                  </TableCell>
                </TableRow>
                <TableBody>
                  {adicionales.sociedades.map((sociedad) => (
                    <TableRow key={sociedad.id}>
                      <TableCell sx={{ padding: "4px 8px" }}>
                        {sociedad.tipo_documento} - {sociedad.numero_documento}
                      </TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>{sociedad.nombre_completo}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>{sociedad.tipo_sociedad}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>
                        {sociedad.direccion_notificacion}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        ) : (
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              <Typography>No hay Sociedades registradas.</Typography>
            </Grid>
          </Grid>
        )}
      </SuiBox>
    </Card>
  );
}

CardAdicionales.propTypes = {
  proceso: PropTypes.object.isRequired,
  adicionales: PropTypes.shape({
    personasCargo: PropTypes.array.isRequired,
    procesosJudiciales: PropTypes.array.isRequired,
    sociedades: PropTypes.array.isRequired,
  }).isRequired,
};

export default CardAdicionales;
